import React from 'react';
import PropTypes from 'prop-types';
import { useConfigService } from '@thd-nucleus/experience-context';
import { ShippingThreshold } from './ShippingThreshold';
import {
  formatDate,
  showTodayOrTomorrow,
  showDateOrDateRange,
  formatInventory
} from '../../../helper/utils';
import { TileHead } from '../TileHead';
import { TileFooter } from '../TileFooter';
import { useAssemblyListeners } from '../../../../hooks/useAssemblyListeners';
import { FULFILLMENT_METHODS } from '../../../constants';
import { IDS } from '../../../../automationTestIds';

const DefaultShipping = ({
  deliveryStartDate,
  deliveryEndDate,
  deliveryTimeline,
  type,
  hasFreeShipping,
  freeDeliveryThreshold,
  totalCharge,
  maxInventoryAvail,
  backordered,
  lineItemId,
  maxCartPriceContributor,
  consolidatedDeliveryCharge,
  selected,
  isCartTiles,
  testID
}) => {
  const formattedStartDate = formatDate(deliveryStartDate);
  const formattedEndDate = formatDate(deliveryEndDate);
  const formattedInventoryQty = formatInventory(maxInventoryAvail);

  const isBodfsGrillsAssemblyEnabled = useConfigService('bodfsGrillsAssemblyEnabled');
  const { isBODFSAssemblySelected } = useAssemblyListeners({ isBodfsGrillsAssemblyEnabled });

  const showDeliveryStartDate = deliveryStartDate || deliveryEndDate;

  function renderDeliveryStartDate() {
    if ((type === FULFILLMENT_METHODS.EXPRESS_DELIVERY && isBODFSAssemblySelected) || !showDeliveryStartDate) {
      return (
        <div className="u__bold delivery-timeline" data-automation-id={IDS.ETA.sthETA}>
          &nbsp;
        </div>
      );
    }

    if (formattedStartDate === formattedEndDate) {
      return (
        <div className="u__bold delivery-timeline" data-automation-id={IDS.ETA.sthETA}>
          {showTodayOrTomorrow(deliveryEndDate, true, deliveryTimeline, formattedEndDate)}
        </div>
      );
    }

    return (
      <div className="u__bold delivery-timeline" data-automation-id={IDS.ETA.sthETA}>
        {showDateOrDateRange({ formattedStartDate, formattedEndDate })}
      </div>
    );
  }

  return (
    <div className="fulfillment-tile" data-testid={testID}>
      <TileHead
        title="Delivery"
        automationId={IDS.LABEL.sthLabel}
      />
      <div className="fulfillment__sub-title">
        {renderDeliveryStartDate()}
        {backordered && type === FULFILLMENT_METHODS.STH_FFM ? (
          <div className="fulfillment-qty-row" data-automation-id={IDS.QTY.sthQty}>Backordered</div>
        ) : !!formattedInventoryQty && (
          <div className="fulfillment-qty-row" data-automation-id={IDS.QTY.sthQty}>
            <span className="u__text--success">{formattedInventoryQty}</span> available
          </div>
        )}
      </div>
      <TileFooter>
        <ShippingThreshold
          type={type}
          hasFreeShipping={hasFreeShipping}
          freeDeliveryThreshold={freeDeliveryThreshold}
          totalCharge={totalCharge}
          lineItemId={lineItemId}
          maxCartPriceContributor={maxCartPriceContributor}
          consolidatedDeliveryCharge={consolidatedDeliveryCharge}
          selected={selected}
          isCartTiles={isCartTiles}
        />
      </TileFooter>
    </div>
  );
};

DefaultShipping.propTypes = {
  deliveryStartDate: PropTypes.string,
  deliveryEndDate: PropTypes.string,
  deliveryTimeline: PropTypes.string,
  type: PropTypes.string,
  hasFreeShipping: PropTypes.bool,
  freeDeliveryThreshold: PropTypes.number,
  totalCharge: PropTypes.number,
  maxInventoryAvail: PropTypes.number,
  backordered: PropTypes.bool,
  lineItemId: PropTypes.string,
  maxCartPriceContributor: PropTypes.string,
  consolidatedDeliveryCharge: PropTypes.number,
  selected: PropTypes.bool,
  isCartTiles: PropTypes.bool,
  testID: PropTypes.string
};

DefaultShipping.defaultProps = {
  deliveryStartDate: null,
  deliveryEndDate: null,
  deliveryTimeline: null,
  type: null,
  hasFreeShipping: false,
  freeDeliveryThreshold: null,
  totalCharge: null,
  maxInventoryAvail: null,
  backordered: false,
  lineItemId: null,
  maxCartPriceContributor: null,
  consolidatedDeliveryCharge: null,
  selected: false,
  isCartTiles: false,
  testID: ''
};

export { DefaultShipping };
